import { Col, Form, Modal, Row, Table } from 'react-bootstrap'
import { CustomButton } from '../../../../components/CustomButton'
import { ArrowRepeat, Search, XCircleFill } from 'react-bootstrap-icons'
import { IconButton } from '../../../../components/IconButton'
import { useState } from 'react'
import { sendErrorApiMessage } from '../../../../utils/sendErrorApiMessage'
import apinode from '../../../../services/apinode'
import { CustomSpinner } from '../../../../components/CustomSpinner'
import { Center } from '../../../../components/Center'

export function ModalAddToList({ isOpen, product, onClose, onAddProduct }) {
  const [data, setData] = useState({
    tipo_ajuste: 'E',
    quantidade: '',
    ajustar_estoque_gerencial: 'N',
    cod_motivo: '',
    desc_motivo: '',
    obs: '',
  })
  const [motivos, setMotivos] = useState([])
  const [isMotivosLoading, setIsMotivosLoading] = useState([])
  const [isModalSelectMotivosOpen, setIsModalSelectMotivosOpen] =
    useState(false)

  function handleChange(e) {
    const { name, value } = e.target

    setData((prevState) => ({
      ...prevState,
      [name]: value,
    }))
  }

  async function loadMotivos() {
    try {
      setIsMotivosLoading(true)

      const response = await apinode.get(`/motivos/${localStorage.idconta}`)

      setMotivos(response.data)
    } catch (err) {
      sendErrorApiMessage(err, 'Não foi possível carregar os motivos!')
    } finally {
      setIsMotivosLoading(false)
    }
  }

  return (
    <>
      <Modal
        show={isOpen}
        size="lg"
        dialogClassName="custom-modalzpl"
      >
        <Modal.Body>
          <p>Dados do Produto</p>

          <Row className="mb-3">
            <Col>
              <Form.Label>SKU</Form.Label>
              <Form.Control
                disabled
                value={product.sku || ''}
              />
            </Col>

            <Col>
              <Form.Label>Descrição</Form.Label>
              <Form.Control
                disabled
                value={product.descricao || ''}
              />
            </Col>
          </Row>

          <Row className="mb-3">
            <Col>
              <Form.Label>Depósito</Form.Label>
              <Form.Control
                disabled
                value={product.deposito || ''}
              />
            </Col>

            <Col>
              <Form.Label>Rua</Form.Label>
              <Form.Control
                disabled
                value={product.rua || ''}
              />
            </Col>

            <Col>
              <Form.Label>Prédio</Form.Label>
              <Form.Control
                disabled
                value={product.predio || ''}
              />
            </Col>

            <Col>
              <Form.Label>Nível</Form.Label>
              <Form.Control
                disabled
                value={product.nivel}
              />
            </Col>

            <Col>
              <Form.Label>Apto</Form.Label>
              <Form.Control
                disabled
                value={product.apto || ''}
              />
            </Col>

            <Col>
              <Form.Label>Quantidade</Form.Label>
              <Form.Control
                disabled
                value={product.qt}
              />
            </Col>

            <Col>
              <Form.Label>Bloqueada</Form.Label>
              <Form.Control
                disabled
                value={product.qtbloqueada}
              />
            </Col>
          </Row>

          <p>Informar Dados</p>

          <Row className="mb-3">
            <Col>
              <Form.Label>Tipo de Ajuste</Form.Label>
              <Form.Select
                name="tipo_ajuste"
                value={data.tipo_ajuste}
                onChange={handleChange}
              >
                <option value="E">Entrada</option>
                <option value="S">Saída</option>
              </Form.Select>
            </Col>

            <Col>
              <Form.Label>Quantidade</Form.Label>
              <Form.Control
                name="quantidade"
                value={data.quantidade}
                onChange={handleChange}
              />
            </Col>

            <Col>
              <Form.Label>Ajustar Estoque Gerencial</Form.Label>
              <Form.Select
                name="ajustar_estoque_gerencial"
                value={data.ajustar_estoque_gerencial}
                onChange={handleChange}
              >
                <option value="S">Sim</option>
                <option value="N">Não</option>
              </Form.Select>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col xs={2}>
              <Form.Label>Cód. Motivo</Form.Label>
              <div
                style={{
                  display: 'flex',
                  gap: 10,
                }}
              >
                <Form.Control
                  name="cod_motivo"
                  value={data.cod_motivo}
                  disabled
                />

                <IconButton onClick={() => setIsModalSelectMotivosOpen(true)}>
                  <Search />
                </IconButton>
              </div>
            </Col>

            <Col>
              <Form.Label>Descrição Motivo</Form.Label>
              <Form.Control
                name="desc_motivo"
                value={data.desc_motivo}
                disabled
              />
            </Col>
          </Row>

          <Row>
            <Form.Label>Observação</Form.Label>
            <Form.Control
              name="obs"
              value={data.obs}
              onChange={handleChange}
            />
          </Row>
        </Modal.Body>

        <Modal.Footer>
          <CustomButton
            title="Processar"
            color="#29ae02"
            onClick={() => {
              onAddProduct({ ...product, ...data })
              onClose()
            }}
            isDisabled={
              !data.quantidade || !data.cod_motivo || !data.desc_motivo
            }
          >
            <ArrowRepeat />
          </CustomButton>

          <CustomButton
            title="Cancelar"
            color="#c01907"
            onClick={onClose}
          >
            <XCircleFill />
          </CustomButton>
        </Modal.Footer>
      </Modal>

      {isModalSelectMotivosOpen && (
        <Modal
          show={isModalSelectMotivosOpen}
          onShow={loadMotivos}
          onHide={() => setIsModalSelectMotivosOpen(false)}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>Selecione o motivo</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            {isMotivosLoading ? (
              <Center>
                <CustomSpinner />
              </Center>
            ) : (
              motivos.length > 0 && (
                <Table hover>
                  <thead>
                    <tr>
                      <th>Cód.</th>
                      <th>Descrição</th>
                    </tr>
                  </thead>

                  <tbody>
                    {motivos.map((motivo) => (
                      <tr
                        key={motivo.codigo}
                        onClick={() => {
                          setData((prevState) => ({
                            ...prevState,
                            cod_motivo: motivo.codigo,
                            desc_motivo: motivo.descricao,
                          }))

                          setIsModalSelectMotivosOpen(false)
                        }}
                        style={{
                          cursor: 'pointer',
                        }}
                      >
                        <td>{motivo.codigo}</td>
                        <td>{motivo.descricao}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              )
            )}
          </Modal.Body>
        </Modal>
      )}
    </>
  )
}
